import { Box, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, unit } from '@hcr/pwa/components'

import { useHomeAuthenticatedQuery } from '../../hooks'
import { createHomeAuthenticatedContent, createLink } from '../../utils'
import { BookingOverviewCompact, LayoutNavigationError500, LayoutNavigationLoading } from '../common'

import { LayoutHome } from './common'

const homeAuthenticatedContent = createHomeAuthenticatedContent({ createLink, slidesMargin: unit(3) })

export const HomeFallback: FC = () => {
  const { t } = useTranslation()

  const homeAuthenticated = useHomeAuthenticatedQuery()

  if (homeAuthenticated.isError) {
    return <LayoutNavigationError500 showContextMenuButton />
  }

  if (homeAuthenticated.isSuccess) {
    return (
      <LayoutHome
        imageUrl={homeAuthenticated.data.imageUrl}
        header={
          <Header>
            <Section>
              <Title variant='displayM'>{t('home.holiday-club-resorts')}</Title>
            </Section>
            <BookingOverviewCompact />
          </Header>
        }
        carousel={homeAuthenticated.data.content.map(homeAuthenticatedContent)}
        showFallbackWarning
      />
    )
  }

  return <LayoutNavigationLoading showContextMenuButton />
}

const Header = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${unit(4)};
`

const Section = styled(Header)`
  padding: 0 ${unit(4)};
`

const Title = styled(Typography)`
  color: ${COLORS.white};
`
